import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=67b695cd&"
import script from "./Safety.vue?vue&type=script&lang=js&"
export * from "./Safety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports